import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import { SeoButton } from 'dibs-seo/exports/SeoButton';
import { getSrcString, getSrcSetString } from '../helpers/getSrcStrings';

import styles from './HpRespEditorialModuleItemOld.scss';

function HpRespEditorialModuleItemOld({ item, alt, onClick }) {
    return (
        <div className={classnames(styles.itemWrapper, 'colXs12 colLg6')}>
            <div className={styles.item}>
                <SeoLink linkData={item.linkData} className={styles.link} onClick={onClick}>
                    <div className={styles.imageWrapper}>
                        <img
                            alt={alt}
                            className={styles.image}
                            src={getSrcString({ url: item.imageUrl })}
                            sizes="(max-width:768px) 95vw, 50vw"
                            srcSet={getSrcSetString({
                                url: item.imageUrl,
                                widths: [400, 640, 800],
                            })}
                        />
                    </div>
                </SeoLink>
                <div className={styles.content}>
                    <div className={styles.description}>{item.description}</div>
                    <SeoButton
                        type="secondary"
                        linkData={item.linkData}
                        className={styles.button}
                        onClick={onClick}
                    >
                        {item.cta}
                    </SeoButton>
                </div>
            </div>
        </div>
    );
}

HpRespEditorialModuleItemOld.propTypes = {
    alt: PropTypes.string,
    item: PropTypes.shape({
        imageUrl: PropTypes.string,
        cta: PropTypes.string,
        description: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    onClick: PropTypes.func,
};

HpRespEditorialModuleItemOld.defaultProps = {
    onClick: () => {},
};

export { HpRespEditorialModuleItemOld };
